var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _c("configs-popup-edit-info", { ref: "configs-popup-edit-info" }),
      _c("c-edit-tag-popup", { ref: "c-edit-tag-popup" }),
      _c("c-edit-group-popup", { ref: "c-edit-group-popup" }),
      _c("c-p-r-deploy-with-merge-popup", {
        ref: "c-p-r-deploy-with-merge-popup",
      }),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-2" },
            [
              _c(
                "v-card",
                {
                  staticClass: "ma-0 pa-0 scroll",
                  attrs: { width: "100%", elevation: "0" },
                },
                [
                  _c("c-pre-release-table", {
                    on: {
                      "show-configs-popup-edit-info": _vm.showEditInfoPopup,
                      "show-c-edit-tag-popup": _vm.showEditTagPopup,
                      "show-c-edit-group-popup": _vm.showEditGroupPopup,
                      "show-c-p-r-deploy-with-merge-popup":
                        _vm.showDeployWithMergePopup,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }